import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../../services/api";

const SetContactEmail = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    setIsFetching(true)
    api.admin.getContactEmail()
      .then((res) => {
        setEmail(res.data['Contact-email'][0].value || "N/A");
      })
      .catch((err) => {
        toast.error("Failed to get Contact Email.");
        console.error("Error getting Contact Email:", err);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [])

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);

    api.admin.setContactEmail(formData)
      .then((res) => {
        console.log(res)
        toast.success("Contact Email updated successfully!");
        setEmail("");
      })
      .catch((err) => {
        toast.error("Failed to set Contact Email.");
        console.error("Error updating contact email:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: 400,
        margin: "0 auto",
        padding: 2,
        boxShadow: 3,
        borderRadius: 1,
        backgroundColor: "white",
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom>
        Set Contact Email
      </Typography>
      {isFetching ? <CircularProgress /> : <TextField
        label="Contact Email"
        variant="outlined"
        name="email"
        value={email}
        onChange={handleInputChange}
        fullWidth
        required
        sx={{ marginBottom: 2 }}
      />}
      <Button type="submit" variant="contained" color="primary" disabled={loading}>
        {loading ? <CircularProgress size={24} /> : "Submit"}
      </Button>
    </Box>
  );
};

export default SetContactEmail